exports = module.exports = require("../../../../../../packages/webapp/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-md-editor-bar {\n  position: absolute;\n  cursor: s-resize;\n  right: 0;\n  margin-top: -11px;\n  margin-right: 0;\n  width: 14px;\n  z-index: 3;\n  height: 10px;\n  border-radius: 0 0 3px 0;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.w-md-editor-bar svg {\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

// exports
